import { useLazyQuery } from '@apollo/client';
import { GET_SEARCH_SERVICE_DETAILS } from 'store/queries';
import { isJourneyDirectEROnly } from 'utils/isJourneyDirectEROnly';
import { someTrainsDepartAtTheSameTime } from 'utils/someTrainsDepartAtTheSameTime';
import serviceTypeCodes from 'constants/serviceTypeCodes';

const useServiceDetailsQuery = () => {
  const [fetchOutbound, { loading: outboundLoading, data: outbound }] = useLazyQuery(GET_SEARCH_SERVICE_DETAILS, {
    fetchPolicy: 'network-only'
  });
  const [fetchInbound, { loading: inboundLoading, data: inbound }] = useLazyQuery(GET_SEARCH_SERVICE_DETAILS, {
    fetchPolicy: 'network-only'
  });

  const handleQueries = async ({ variables: { outboundDate, inboundDate, search, origin, destination, isGroupSearch } }) => {
    if (!isGroupSearch) return;

    if (outboundDate) {
      const containOnlyDirectERTrains = isJourneyDirectEROnly({ journeys: search.outbound.journeys });
      const hasTrainsDepartingAtTheSameTime = someTrainsDepartAtTheSameTime({ journeys: search.outbound.journeys });

      if (containOnlyDirectERTrains && hasTrainsDepartingAtTheSameTime) {
        await fetchOutbound({
          variables: {
            travelDate: outboundDate,
            serviceType: serviceTypeCodes.GREENSPEED,
            originUIC: origin,
            destinationUIC: destination
          }
        });
      }
    }

    if (inboundDate) {
      const containOnlyDirectERTrains = isJourneyDirectEROnly({ journeys: search.inbound.journeys });
      const hasTrainsDepartingAtTheSameTime = someTrainsDepartAtTheSameTime({ journeys: search.inbound.journeys });

      if (containOnlyDirectERTrains && hasTrainsDepartingAtTheSameTime) {
        await fetchInbound({
          variables: {
            travelDate: inboundDate,
            serviceType: serviceTypeCodes.GREENSPEED,
            originUIC: !outboundDate ? origin : destination,
            destinationUIC: !outboundDate ? destination : origin
          }
        });
      }
    }
  };

  return [
    handleQueries,
    {
      data: { outbound: outbound?.getSearchServiceDetails ?? [], inbound: inbound?.getSearchServiceDetails ?? [] },
      loading: { outbound: outboundLoading, inbound: inboundLoading }
    }
  ];
};

export default useServiceDetailsQuery;
